import React, { useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export type EmailContentEditorProps = {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  readOnly?: boolean;
  id?: string;
};

// Keep the toolbar conservative for email-safe HTML
const toolbarModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    ["clean"]
  ]
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "align",
  "list",
  "bullet",
  "link",
  "image"
];

const EmailContentEditor: React.FC<EmailContentEditorProps> = ({
  value,
  onChange,
  placeholder,
  readOnly,
  id
}) => {
  const quillRef = useRef<ReactQuill>(null);

  useEffect(() => {
    // Expose quill instance globally for image insertion
    if (quillRef.current) {
      const quill = quillRef.current.getEditor();
      (window as any).quillInstance = quill;
    }
    return () => {
      delete (window as any).quillInstance;
    };
  }, []);

  return (
    <ReactQuill
      ref={quillRef}
      id={id}
      theme="snow"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      readOnly={readOnly}
      modules={toolbarModules}
      formats={formats}
      style={{ backgroundColor: "#fff" }}
    />
  );
};

export default EmailContentEditor;
